/**
 * Mobile number validation utility
 * Returns min and max length for mobile numbers based on country code
 */

export interface MobileValidationResult {
    min: number
    max: number
}

// Countries with specific mobile number length requirements
const MOBILE_LENGTH_EXCEPTIONS: Record<string, MobileValidationResult> = {
    '91': { min: 10, max: 10 }, // India
    '973': { min: 7, max: 8 }, // Bahrain
    '965': { min: 7, max: 8 }, // Kuwait
    '968': { min: 8, max: 8 }, // Oman
    '974': { min: 8, max: 8 }, // Qatar
    '966': { min: 9, max: 10 }, // Saudi Arabia
    '971': { min: 8, max: 9 } // United Arab Emirates
}

// Default min/max for most countries
const DEFAULT_MOBILE_LENGTH: MobileValidationResult = {
    min: 5,
    max: 15
}

/**
 * Get mobile number validation min/max length for a given country code
 * @param countryCode - ISO 3166-1 alpha-2 country code (e.g., 'IN', 'US', 'GB')
 * @returns Object with min and max length for mobile numbers
 */
export function getMobileValidationLength(countryCode: string): MobileValidationResult {
    if (!countryCode) {
        return DEFAULT_MOBILE_LENGTH
    }

    const upperCountryCode = countryCode.toUpperCase()
    return MOBILE_LENGTH_EXCEPTIONS[upperCountryCode] || DEFAULT_MOBILE_LENGTH
}
